import React, { useState, useContext } from 'react';
import axios from 'axios';
import './ChangePasswordModal.css';
import { LanguageContext } from "../context/LanguageContext";

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const { texts } = useContext(LanguageContext);

  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isDirty, setIsDirty] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIsDirty(true);
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isFormValid = () => {
    const { oldPassword, newPassword, confirmPassword } = formData;
    return (
      oldPassword.trim() !== '' &&
      newPassword.trim() !== '' &&
      confirmPassword.trim() !== '' &&
      newPassword === confirmPassword
    );
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!isFormValid()) {
      setError(texts.password.errorInvalid);
      return;
    }

    const token = localStorage.getItem('authToken');
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/change-password`,
        {
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSuccess(texts.password.success);
      setIsDirty(false);
      setFormData({ oldPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      console.error('Fehler beim Passwort ändern:', err);
      setError(err.response?.data?.message || texts.password.errorGeneral);
    }
  };

  const handleClose = () => {
    if (isDirty) {
      const confirmLeave = window.confirm(texts.password.confirmLeave);
      if (confirmLeave) {
        handleSave(new Event('submit'));
      } else {
        onClose();
      }
    } else {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close-button" onClick={handleClose}>x</button>
        <h2 className="register-header">{texts.password.title}</h2>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <form className="register-form" onSubmit={handleSave}>
          <div className="form-group">
            <label>{texts.password.oldPassword}</label>
            <input
              type="password"
              name="oldPassword"
              value={formData.oldPassword}
              onChange={handleChange}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label>{texts.password.newPassword}</label>
            <input
              type="password"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label>{texts.password.confirmPassword}</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              className="form-input"
            />
          </div>

          <div className="modal-buttons">
            <button type="button" onClick={handleClose}>
              {texts.password.cancel}
            </button>
            <button type="submit" disabled={!isFormValid()}>
              {texts.password.save}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
